import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { usePostSelector } from "@circle-react/components/SettingsApp/Workflows/hooks/usePostSelector";
import { FormTextSelect } from "@circle-react/components/shared/uikit/Form/FormTextSelect";
import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circle-react-uikit/Typography";

const i18nRoot = "settings.workflows.form";

export const PostSelector = () => {
  const {
    formState: { touchedFields },
    register,
    getValues,
  } = useFormContext();
  const isResourceTypeTouched = touchedFields.trigger?.resource_type;

  const selectedPostId = isResourceTypeTouched
    ? null
    : getValues("trigger.resource_id");

  const { isLoading, postOptions, handlePostTitleChange } = usePostSelector({
    selectedPostId,
  });

  if (isLoading) {
    return <Loader center />;
  }

  return (
    <>
      <input
        type="hidden"
        className="hidden"
        {...register("trigger.resource_type")}
      />
      <FormTextSelect
        name="trigger.resource_id"
        label={
          <Typography.LabelSm weight="semibold">
            {t([i18nRoot, "choose_post"])}
          </Typography.LabelSm>
        }
        options={postOptions}
        rules={{
          required: t("settings.workflows.form.errors.required"),
        }}
        emptyMessage={t("settings.workflows.form.errors.posts.not_found")}
        onSearchChange={handlePostTitleChange}
      />
    </>
  );
};
